export default "__VITE_ASSET__puvPm6QA__"